import { key } from 'piqure';

export const URL_SEARCH_PARAMS = key<URLSearchParams>('search-params');
